import { useTranslation } from "react-i18next";
import { Close } from "@mui/icons-material";
import { Box, Button, FormControl, MenuItem, Select } from "@mui/material";
import { useGeneratePostIntroductionMutation } from "../../../../../../redux/slices/featuresApiSlice";
import { useFormikContext } from "formik";
import RewriteModal from "../../SidePanel/global-rewrite-modal/rewrite-modal";
import { useWebSocket } from "../../WebSocketContext";
import { toast } from "react-toastify";
import { GenerationButton } from "../../FeaturesTemplate/FeaturesFields/GenerationButton";
import { useGenerationErrorHandling } from "../../../../../../shared/utils/errorHandling";
import { trackPlatformUsed } from "../../../../../../shared/utils/trackers";

const IntroductionModal = ({ isIntroGenerated }) => {
  const { t } = useTranslation();
  const {
    introHeading,
    setOpenIntroductionModal,
    openIntroductionRewrite,
    setOpenIntroductionRewrite,
    bufferRef,
  } = useWebSocket();
  const [generatePostIntroduction, { isLoading }] =
    useGeneratePostIntroductionMutation();
  const handleGenerationError = useGenerationErrorHandling();
  const formikProps = useFormikContext();

  const handleGenerateIntroduction = async () => {
    trackPlatformUsed("introduction", "ai_generation");
    try {
      let payload = {
        id:
          formikProps.values.id === null || formikProps.values.id === ""
            ? null
            : formikProps.values.id,
        style_id:
          formikProps.values.style_id === null ||
          formikProps.values.style_id === ""
            ? null
            : formikProps.values.style_id,
        company_id:
          formikProps.values.company_id === null ||
          formikProps.values.company_id === ""
            ? null
            : formikProps.values.company_id,
        product_id:
          formikProps.values.product_id === null ||
          formikProps.values.product_id === ""
            ? null
            : formikProps.values.product_id,
        subject: formikProps.values.subject,
        seo_request: formikProps.values.seo_request,
        outline: formikProps.values.outline,
        length: formikProps.values.introduction_length,
        //nb_outputs: formikProps.values.nb_introduction,
      };
      if (isIntroGenerated) {
        payload["introduction"] = formikProps.values.introduction;
      } else {
        introHeading.current = formikProps.values.introduction;
      }

      console.log(`introduction generation payload: `, payload);

      const res = await generatePostIntroduction({
        ...payload,
        ...{ stream: true },
      }).unwrap();

      if (res?.status !== 200) {
        toast.error(
          t(
            "something-went-wrong-with-generation",
            "Une erreur s'est produite lors de la génération"
          )
        );
        return;
      }

      console.log(`introduction generation res: `, res);

      if (!isIntroGenerated) {
        const introzone = document.getElementById("introzone");
        if (introzone) {
          introzone.innerHTML = introHeading.current + res?.data;
        }
      } else {
        formikProps.setFieldValue("introduction_rewrite", res?.data);
      }

      introHeading.current = "";
      bufferRef.current = "";
    } catch (error) {
      handleGenerationError(error);
    }
  };

  const saveSelectedVersion = (data) => {
    const zone = document.getElementById("introzone");
    if (zone) {
      zone.innerHTML = data;
    }
    formikProps.setFieldValue("introduction_rewrite", "");
    setOpenIntroductionRewrite(false);
    setOpenIntroductionModal(false);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        //overflow: { md: 'unset', xs: 'scroll' },
        height: "100vh",
        width: {
          lg: "calc(100vw - 500px)",
          md: "calc(100vw - 350px)",
          xs: "100%",
        },
        display: "flex",
        mt: { md: "48px !important", xs: "unset" },
        left: 0,
        top: 0,
        bgcolor: "#000000a1",
        zIndex: 99999,
      }}
    >
      {openIntroductionRewrite ? (
        <RewriteModal
          previous={formikProps.values.introduction}
          rewritten={formikProps.values.introduction_rewrite}
          save={saveSelectedVersion}
          label={t("Introduction-Rewrite", "Introduction (réécriture)")}
          setOpenModal={setOpenIntroductionRewrite}
          rewriteFieldName="introduction_rewrite"
        />
      ) : (
        <div className="m-auto bg-white rounded-xl w-[80%] max-w-[500px]">
          <div className="flex justify-between p-4 items-center border-b-[3px] border-slate-200">
            <p>{!isIntroGenerated ? "Introduction" : `(Re) Introduction`}</p>
            <Close
              onClick={() => setOpenIntroductionModal(false)}
              className="cursor-pointer"
              sx={{ fontSize: 32 }}
            />
          </div>
          <div className="p-4">
            <FormControl sx={{ mb: 2 }} fullWidth>
              <p className="mb-2">
                {t("Generate-introduction", "Générer une introduction")}
              </p>
              <Select
                sx={{ bgcolor: "white" }}
                value={formikProps.values.introduction_length}
                onChange={(e) =>
                  formikProps.setFieldValue(
                    "introduction_length",
                    e.target.value
                  )
                }
              >
                <MenuItem value={"courte"}>{t("Short", "Courte")}</MenuItem>
                <MenuItem value={"moyenne"}>{t("Medium", "Moyenne")}</MenuItem>
                <MenuItem value={"longue"}>{t("Long", "Longue")}</MenuItem>
              </Select>
            </FormControl>

            <div className="flex items-center gap-4">
              <GenerationButton
                formikProps={formikProps}
                text={t("Generate-introduction", "Générer une introduction")}
                handleGenerate={handleGenerateIntroduction}
                isLoading={isLoading}
                platform="openai"
              />

              {formikProps.values.introduction_rewrite !== "" ? (
                <Button
                  variant="contained"
                  className="!bg-violet-400 hover:!bg-violet-500 text-white !normal-case"
                  onClick={() => setOpenIntroductionRewrite(true)}
                >
                  {t("View-rewritten-version", "Voir la version réécrite")}
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      )}

      {/* {rewrite ? (
          <RewriteModal
            previous={formikProps.values.introduction}
            rewritten={formikProps.values.introduction_rewrite}
          />
        ) : null} */}
    </Box>
  );
};

export default IntroductionModal;
